import {Epic, ofType} from "redux-observable";
import {AppActions} from "../actions";
import {AppState, CurrentSelectedCompanyPermissions} from "../AppState";
import {map, mergeMap, switchMap} from "rxjs/operators";
import {fromFetch} from "rxjs/fetch";
import ApiUrl from "../api/ApiUrl";
import {BuildAuthRequestFromAppState} from "../authentication/BuildAuthRequestInterface";
import {WorkforcePermissionChanged} from "../actions/WorkforceOnePermissionActions";
import {USER_LOGGED_IN, WorkforceOneLoggedInAction} from "../actions/WorkforceOneLoginActions";
import ApiResponse from "../api/ApiResponse";

const WorkforceOneUserAccess:  Epic<AppActions, AppActions, AppState> = (action$, states$) => {
    return action$.pipe(
        ofType(USER_LOGGED_IN),
        mergeMap((action: AppActions) => {
                const authDetails = BuildAuthRequestFromAppState(states$.value);
                const loginDetailFromAction = action as WorkforceOneLoggedInAction;
                return fromFetch(`${ApiUrl()}FFOrderAccount/GetUserAccess`,
                    {
                        method: 'GET',
                        credentials: 'omit',
                        headers: new Headers({
                            'auth_token': loginDetailFromAction.payload.AuthToken,
                            'IsMarketPlace': authDetails.IsMarketPlace,
                            'Agent': authDetails.Agent,
                            'api_version': authDetails.api_version,
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        }),
                    })
                    .pipe(switchMap(response => response.ok ?
                        response.json() :
                        Promise.resolve(null)))
                    .pipe(map((json: ApiResponse<CurrentSelectedCompanyPermissions> | null) => {
                        if(json){
                            return WorkforcePermissionChanged(json.data)
                        }else{
                            return WorkforcePermissionChanged(json)
                        }
                    }))
            }
        )
    );
};
export default WorkforceOneUserAccess;
